import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/home';
import CreateAlert from './pages/createAlert/createAlert';
import NavBar from './components/NavBar';

function App() {
  return (
    <div className="App">
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create-alert" element={<CreateAlert />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
